var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFlat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1667 32.2365H4.16667V9.83317H17V6.1665H4.16667C2.15 6.1665 0.5 7.8165 0.5 9.83317V31.8332C0.5 33.8498 2.15 35.4998 4.16667 35.4998H26.1667C28.1833 35.4998 29.8333 33.8498 29.8333 31.8332V18.9998H26.1667V32.2365Z",
    fill: "#3F444D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8332 0.666504H26.1665V6.1665H20.6665C20.6848 6.18484 20.6665 9.83317 20.6665 9.83317H26.1665V15.3148C26.1848 15.3332 29.8332 15.3148 29.8332 15.3148V9.83317H35.3332V6.1665H29.8332V0.666504Z",
    fill: "#3F444D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5002 13.5H7.8335V17.1667H22.5002V13.5Z",
    fill: "#3F444D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 19V22.6667H22.5002V19H17.0002H7.8335Z",
    fill: "#3F444D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5002 24.5H7.8335V28.1667H22.5002V24.5Z",
    fill: "#3F444D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlat);
export default __webpack_public_path__ + "static/media/IconFlat.00b3ecc72ae8772865f46cc63e929ded.svg";
export { ForwardRef as ReactComponent };